import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { title: 'María Cerdán' }
    },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
      meta: { title: 'About' }
    },
    {
      path: '/work',
      name: 'work',
      component: () => import(/* webpackChunkName: "work" */ './views/Work.vue'),
      meta: { title: 'Work' }
    },
    {
      path: '/work/:slug',
      name: 'client',
      component: () => import(/* webpackChunkName: "work" */ './views/SingleWork.vue'),
      meta: { title: 'Work' }
    }
  ],
  scrollBehavior (to, from, savedPosition) { return { x: 0, y: 0 } }
})
